module.exports = __webpack_public_path__ + "img/logo_utopia.f6e74c15.svg";